import { createComponent as _$createComponent } from "solid-js/web";
/** @jsxImportSource solid-js */
import { render } from 'solid-js/web';
import App from './App';
import './styles.css';
render(() => _$createComponent(App, {}), document.getElementById('app'));